/**
 * GENERATED by scripts/derive-footprints.mjs — do not edit.
 *
 * Each component's extent in world units, measured about the origin its model
 * was authored with, in the game's frame (x across, y along the deck, up off
 * it). Re-run the script after re-exporting a model and the bounds follow.
 *
 * Deliberately *not* recentred: for an edge component the origin is the point
 * it bolts onto the hull, and its barrel or bell sticks out past that on
 * purpose. See the script's header.
 */
export const MODEL_BOUNDS = {
    collector: {
        x: { min: -0.3798, max: 0.3798 },
        y: { min: -0.3798, max: 0.3798 },
        up: { min: -0.3857, max: 0.3738 },
    },
    landinggear_active: {
        x: { min: -0.3, max: 0.3 },
        y: { min: -0.5, max: 0.5 },
        up: { min: -0.9993, max: 0.0108 },
    },
    landinggear_inactive: {
        x: { min: -0.3, max: 0.3 },
        y: { min: -0.5, max: 0.5 },
        up: { min: -0.2085, max: 0.0108 },
    },
    pilot_seat: {
        x: { min: -0.5, max: 0.5 },
        y: { min: -1, max: 1 },
        up: { min: 0.0087, max: 0.9881 },
    },
    small_engine: {
        x: { min: -1, max: 1 },
        y: { min: -1, max: 1 },
        up: { min: 0.008, max: 1.09 },
    },
    thruster: {
        x: { min: -0.5, max: 0.5 },
        y: { min: -0.6992, max: 0.33 },
        up: { min: -0.5, max: 0.5 },
    },
    turret: {
        x: { min: -0.15, max: 0.15 },
        y: { min: -0.15, max: 1.0312 },
        up: { min: -0.15, max: 0.15 },
    },
    vault: {
        x: { min: -0.5287, max: 0.5287 },
        y: { min: -0.5287, max: 0.5287 },
        up: { min: 0.0115, max: 1.0687 },
    },
};
//# sourceMappingURL=footprints.generated.js.map